module.exports = __webpack_public_path__ + "static/demoaccesspluscompany-logo-262076d9016bf6e552d6c734543fdb41.png";